import {ReplenishmentReportPageContext} from '../contexts'
import useGetReplenishmentReportList from '../hooks/useGetReplenishmentReportList'
import usePermission from '../../../hook/usePermission'
import ReplenishmentReportTable from '../sections/table/ReplenishmentReportTable'

export default function ReplenishmentReport() {
  const {
    replenishmentReportList,
    isLoading,
    filters,
    onSortingChange,
    meta,
  } = useGetReplenishmentReportList()

  const {hasPermission} = usePermission()
  const hasWritePermission = hasPermission('analytics_replenishment_report', 'write') || false

  const contextValue = {
    hasWritePermission,
    replenishmentReportList,
    isLoading,
    filters,
    onSortingChange,
    meta,
  }

  return (
    <ReplenishmentReportPageContext.Provider value={contextValue}>
      <ReplenishmentReportTable />
    </ReplenishmentReportPageContext.Provider>
  )
}
